module.exports = require('./helpers/bundle-url').getBundleURL('jWbtw') + "BUSDLogo.a70524b3.svg";